export { default } from './AreaSwitcher';
